export function storeRoute(route) {
    return {
        type: "STORE_ROUTE",
        payload: route
    };
}
